import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Country } from '@aw/shared/constants';

@Component({
  standalone: true,
  selector: 'aw-country-flag',
  templateUrl: 'country-flag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryFlagComponent {
  @Input({ required: true }) country: Country;
}
